export default "__VITE_ASSET__BcNEKaYM__"